// Configuração do basemap. Por padrão usa os tiles escuros da CARTO
// (dependência de terceiro: cada tile requisitado expõe IP + área visível
// ao provedor). Para self-host ou outro provedor, defina em build:
//   VITE_TILE_URL="https://meu-servidor/tiles/{z}/{x}/{y}.png"
//   VITE_TILE_ATTRIBUTION="&copy; ..."
// Ver docs/plans/endurecimento-producao-qa.md (Fase 6.2).

export const DEFAULT_TILE_URL =
  'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';

export const DEFAULT_TILE_ATTRIBUTION =
  '&copy; <a href="https://carto.com/attributions">CARTO</a> | &copy; OpenStreetMap contributors';

export const TILE_URL = import.meta.env.VITE_TILE_URL || DEFAULT_TILE_URL;

export const TILE_ATTRIBUTION =
  import.meta.env.VITE_TILE_ATTRIBUTION || DEFAULT_TILE_ATTRIBUTION;
